import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import {
  CmsBreadcrumbsComponent, CmsService,
  Page,
  PageMetaService, ProductSearchPage, ProductSearchService,
  TranslationService,
  isNotNullable,
} from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { BehaviorSubject, Observable, Subscription, combineLatest, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ICON_TYPE } from '../../../../../custom/icons/icon.model';

@Component({
  selector: 'cx-breadcrumb',
  templateUrl: './custom-breadcrumb.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomBreadcrumbComponent implements OnInit, OnDestroy {
  protected subscriptions: Subscription = new Subscription();
  title$: Observable<string>;
  crumbs$: Observable<any[]>;
  iconTypes = ICON_TYPE;
  isHomePage$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  protected pageTypeSubscription: Subscription = new Subscription();

  constructor(
    public component: CmsComponentData<CmsBreadcrumbsComponent>,
    protected pageMetaService: PageMetaService,
    private translation: TranslationService,
    private _location: Location,
    private cmsService: CmsService,
    private productSearchService: ProductSearchService,
  ) {}

  ngOnInit(): void {
    this.setCrumbs();
    this.subscriptions.add(this.cmsService.getCurrentPage()
      .subscribe((сurrentPage: Page) => сurrentPage?.pageId?.indexOf('homepage') > -1
        ? this.isHomePage$.next(true)
        : this.isHomePage$.next(false)));
    this.pageTypeSubscription.add(
      this.cmsService.getCurrentPage().pipe(
        map((pageInfo: any) => {
          if (pageInfo?.pageId !== 'categoryFamilies' && pageInfo?.pageId !== 'productList') {
            return this.setTitle();
          } else if (pageInfo?.pageId === 'productList') {
            this.subscriptions.add(this.productSearchService.getResults().pipe(
              filter((val: ProductSearchPage) => !!Object.keys(val).length),
            )
              .subscribe((page: ProductSearchPage) => {
                if (!!page.title) {
                  return this.title$ = of(page.title);
                } else if (page?.breadcrumbs && page?.breadcrumbs[0]?.facetValueName) {
                  return this.title$ = of(page.breadcrumbs[0]?.facetValueName);
                }
              }));
            return null;
          }
          this.setTitle();
        })
      ).subscribe());
  }

  private setTitle(): void {
    this.title$ = this.pageMetaService.getMeta().pipe(
      filter(isNotNullable),
      map((meta) => (meta.heading || meta.title) ?? '')
    );
  }

  private setCrumbs(): void {
    this.crumbs$ = combineLatest([
      this.pageMetaService.getMeta(),
      this.translation.translate('common.home'),
    ]).pipe(
      map(([meta, textHome]) =>
        meta?.breadcrumbs ? meta.breadcrumbs : [{ label: textHome, link: '/' }]
      )
    );
  }

  back(): void {
    this._location.back();
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    if (this.pageTypeSubscription) {
      this.pageTypeSubscription.unsubscribe();
    }
  }
}
